<template lang="pug">
  v-row.pa-4.mx-0(dense)
    v-col.shrink
      feature-avatar(
        v-shared-element:[heroId]="{ includeChildren: true, ignoreTransparency: true }"
        :size="40"
        :src="$get(avatar, `src`)"
        :src-lazy="$get(avatar, `srcLazy`)")
    v-col
      v-text-field(
        :label="label || `Que voulez-vous dire ?`"
        @click="onGoToPublish"
        rounded
        dense
        solo
        single-line
        hide-details
        readonly)
</template>

<script>
import router from '@iez/core/router/'

export default {
  props: {
    onGoToPublish: Function,
    heroId: String,
    avatar: Object,
    label: String
  }
}
</script>
